/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./IndexFooterMobile.vue?vue&type=template&id=77d3249a&scoped=true"
import script from "./IndexFooterMobile.vue?vue&type=script&lang=js"
export * from "./IndexFooterMobile.vue?vue&type=script&lang=js"
import style0 from "./IndexFooterMobile.vue?vue&type=style&index=0&id=77d3249a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d3249a",
  null
  
)

export default component.exports